import { createContext } from "react";


const navContext = createContext({
	testLoggedIn: false,
	setTestSetLoggedIn: (login) => {}
});

export default navContext;